var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fpaDetail" },
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _vm.canUpdate ||
      _vm.nfcAdminSubmit ||
      _vm.canMenuVpApprove ||
      _vm.canScmVpApprove ||
      _vm.canCfoVpApprove ||
      _vm.canCeoApprove ||
      _vm.canCgoApprove ||
      _vm.formData.canAudit
        ? _c(
            "el-row",
            {
              staticClass: "btn",
              attrs: { type: "flex", justify: "start", align: "middle" },
            },
            [
              _vm.canUpdate
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fpaLtoCampaignSave },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                  )
                : _vm._e(),
              _vm.canUpdate && _vm.isOwner
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSelNfs } },
                    [_vm._v("选择NFS")]
                  )
                : _vm._e(),
              _vm.canUpdate && _vm.isOwner
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fpaLtoCampaignSubmit },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.submit")))]
                  )
                : _vm._e(),
              _vm.nfcAdminSubmit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fpaNfcAdminSubmit },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.submit")))]
                  )
                : _vm._e(),
              _vm.canMenuVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canMenuVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canScmVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canScmVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canCfoVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canCfoVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canCeoApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canCeoApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canCgoApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canCgoApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.formData.canAudit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.formData.canAudit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "formData1",
          attrs: {
            model: _vm.formData,
            "label-width": "230px",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "view_content" }, [
            _c("div", { staticClass: "fpaNo" }, [
              _c("p", [_vm._v("FPA NO:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.fpaNo))]),
            ]),
            _c("div", { staticClass: "status" }, [
              _c("p", [_vm._v("Status:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.queryStatus))]),
            ]),
            _c("div", { staticClass: "creator" }, [
              _c("p", [_vm._v("Creator:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.createUser))]),
            ]),
            _c("div", { staticClass: "createDate" }, [
              _c("p", [_vm._v("Creation Date:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.createDate))]),
            ]),
            _c("div", { staticClass: "approver" }, [
              _c("p", [_vm._v("Last Approver:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.lastApprover))]),
            ]),
          ]),
          _c("div", { staticClass: "info_box_father" }, [
            _c("div", { staticClass: "info_box" }, [
              _c("div", { staticClass: "info_box_lf" }, [
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "info_box_title" }, [
                      _c("p", { staticClass: "line" }),
                      _c("p", { staticClass: "info_title" }, [
                        _vm._v("Basic Information"),
                      ]),
                    ]),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { prop: "purposeOfTheAgreement" },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", {
                                      staticClass: "icon-fenlei element_icon",
                                    }),
                                    _vm._v(" Purpose of the Agreement "),
                                  ]
                                ),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: !_vm.canUpdate || !_vm.isOwner,
                                    },
                                    model: {
                                      value: _vm.formData.agreementPurpose,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "agreementPurpose",
                                          $$v
                                        )
                                      },
                                      expression: "formData.agreementPurpose",
                                    },
                                  },
                                  _vm._l(
                                    _vm.agreementPurposeList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label:
                                            _vm._f("inputChoiceI18n")(item),
                                          value: item.code,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.showAll
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { prop: "ltoSupplier" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "el-icon-user-solid element_icon",
                                        }),
                                        _vm._v(" Supplier "),
                                      ]
                                    ),
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: "",
                                        title: _vm.formData.ltoSupplier,
                                      },
                                      model: {
                                        value: _vm.formData.ltoSupplier,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "ltoSupplier",
                                            $$v
                                          )
                                        },
                                        expression: "formData.ltoSupplier",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 13 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "agreementStartDate",
                                  rules: _vm.fpaRules.agreementStartDate,
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", {
                                      staticClass: "el-icon-date element_icon",
                                      staticStyle: {
                                        "font-size": "24px!important",
                                      },
                                    }),
                                    _vm._v(" Campaign Start Date "),
                                  ]
                                ),
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    placeholder: "选择日期",
                                    "value-format": "yyyy-MM-dd",
                                    disabled: !_vm.canUpdate || !_vm.isOwner,
                                    "picker-options":
                                      _vm.AgreementPickerOptionsStart,
                                  },
                                  model: {
                                    value: _vm.formData.agreementStartDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "agreementStartDate",
                                        $$v
                                      )
                                    },
                                    expression: "formData.agreementStartDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: "Campaign End Date",
                                  "label-width": "140px",
                                  prop: "agreementEndDate",
                                  rules: _vm.fpaRules.agreementEndDate,
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    placeholder: "选择日期",
                                    "value-format": "yyyy-MM-dd",
                                    disabled: !_vm.canUpdate || !_vm.isOwner,
                                    "picker-options":
                                      _vm.AgreementPickerOptionsEnd,
                                  },
                                  model: {
                                    value: _vm.formData.agreementEndDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "agreementEndDate",
                                        $$v
                                      )
                                    },
                                    expression: "formData.agreementEndDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "productOrCommodityPurchased",
                                  rules:
                                    _vm.fpaRules.productOrCommodityPurchased,
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-notebook-2 element_icon",
                                    }),
                                    _vm._v(" Product or Commodity Purchased "),
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    title:
                                      _vm.formData.productOrCommodityPurchased,
                                    disabled: !_vm.canUpdate || !_vm.isOwner,
                                  },
                                  model: {
                                    value:
                                      _vm.formData.productOrCommodityPurchased,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "productOrCommodityPurchased",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.productOrCommodityPurchased",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.showAll
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { prop: "estimateVolumeOfPurchase" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "icon-shuliang element_icon",
                                        }),
                                        _vm._v(" Estimate Volume of Purchase "),
                                      ]
                                    ),
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled:
                                          !_vm.estimateVolumeOfPurchaseUpdate,
                                      },
                                      model: {
                                        value:
                                          _vm.formData.estimateVolumeOfPurchase,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "estimateVolumeOfPurchase",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.estimateVolumeOfPurchase",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 13 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "ssFeedbackHour",
                                  rules: _vm.fpaRules.ssFeedbackHour,
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "required_p",
                                    attrs: { slot: "label" },
                                    slot: "label",
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "icon-fankui element_icon",
                                    }),
                                    _vm._v(" SS Feedback Time(H) "),
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.canUpdate || !_vm.isOwner,
                                  },
                                  on: { change: _vm.changeSsFeedbackHour },
                                  model: {
                                    value: _vm.formData.ssFeedbackHour,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "ssFeedbackHour",
                                        $$v
                                      )
                                    },
                                    expression: "formData.ssFeedbackHour",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: "SS Feedback Deadline",
                                  "label-width": "140px",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "", disabled: true },
                                  model: {
                                    value: _vm.formData.ssFeedbackDeadline,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "ssFeedbackDeadline",
                                        $$v
                                      )
                                    },
                                    expression: "formData.ssFeedbackDeadline",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "info_box_rg" }, [
                _c("div", { staticClass: "national_box" }, [
                  _c("div", { staticClass: "info_box_title" }, [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("Notional Value of Agreement"),
                    ]),
                  ]),
                  _c("div", { staticClass: "price_box1" }, [
                    _c("span", { staticClass: "icon-huobi qian" }),
                    _c("p", { staticClass: "notional_qian" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formData.notionalValueOfAgreement) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "coverage_box" }, [
                  _c(
                    "div",
                    {
                      staticClass: "info_box_title",
                      staticStyle: { "margin-top": "10px" },
                    },
                    [
                      _vm.showAll || (!_vm.showAll && _vm.nfsLists.length > 0)
                        ? _c("p", { staticClass: "line" })
                        : _vm._e(),
                      _vm.showAll
                        ? _c("p", { staticClass: "info_title" }, [
                            _vm._v("Coverage"),
                          ])
                        : _vm._e(),
                      !_vm.showAll && _vm.nfsLists.length > 0
                        ? _c("p", { staticClass: "info_title" }, [
                            _vm._v("NFS"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "coverage_table" },
                    [
                      _vm.showAll
                        ? _c("table", { staticClass: "table-d" }, [
                            _c("tr", [
                              _c("td", { staticClass: "title" }, [_vm._v("#")]),
                              _c("td", { staticClass: "title" }, [
                                _vm._v("Coverage"),
                              ]),
                              _c("td", { staticClass: "title" }, [
                                _vm._v("Percentage"),
                              ]),
                            ]),
                            _c("tr", [
                              _c("td", [_vm._v("1")]),
                              _c("td", [_vm._v("Supplier Coverage")]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        "label-width": "0",
                                        prop: "supplierCoverageTotal",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: !_vm.nfcAdminSubmit,
                                        },
                                        model: {
                                          value:
                                            _vm.formData.supplierCoverageTotal,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "supplierCoverageTotal",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.supplierCoverageTotal",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("tr", [
                              _c("td", [_vm._v("2")]),
                              _c("td", [_vm._v("McDonald's Coverage")]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        "label-width": "0",
                                        prop: "mcdCoverageTotal",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: !_vm.nfcAdminSubmit,
                                        },
                                        model: {
                                          value: _vm.formData.mcdCoverageTotal,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "mcdCoverageTotal",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.mcdCoverageTotal",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      !_vm.showAll && _vm.nfsLists.length > 0
                        ? _c(
                            "el-table",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-bottom": "10px",
                              },
                              attrs: {
                                data: _vm.nfsLists,
                                border: "",
                                "max-height": "104px",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "name", label: "NFS" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm.showAll
              ? _c(
                  "div",
                  { staticClass: "cost_analysis" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info_box_title",
                        staticStyle: { "padding-top": "10px" },
                      },
                      [
                        _c("p", { staticClass: "line" }),
                        _c("p", { staticClass: "info_title" }, [
                          _vm._v("Cost Analysis"),
                        ]),
                      ]
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "costImpactVsCurrentPrice",
                                  "label-width": "230px",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _vm._v(
                                      "Cost Impact (K RMB) vs Current Price"
                                    ),
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.nfcAdminSubmit,
                                    type: "textarea",
                                    rows: 2,
                                    title:
                                      _vm.formData.costImpactVsCurrentPrice,
                                  },
                                  model: {
                                    value:
                                      _vm.formData.costImpactVsCurrentPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "costImpactVsCurrentPrice",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.costImpactVsCurrentPrice",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "currentPrice",
                                  "label-width": "230px",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [_vm._v("Identify Benchmark or Index")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "line-height": "1" },
                                    attrs: { slot: "label" },
                                    slot: "label",
                                  },
                                  [_vm._v("(if available)Current Price")]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.nfcAdminSubmit,
                                    type: "textarea",
                                    rows: 2,
                                  },
                                  model: {
                                    value: _vm.formData.currentPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "currentPrice",
                                        $$v
                                      )
                                    },
                                    expression: "formData.currentPrice",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "futureMarketPrice",
                                  "label-width": "230px",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [_vm._v("Future Market Price(if available)")]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.nfcAdminSubmit,
                                    type: "textarea",
                                    rows: 2,
                                  },
                                  model: {
                                    value: _vm.formData.futureMarketPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "futureMarketPrice",
                                        $$v
                                      )
                                    },
                                    expression: "formData.futureMarketPrice",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "costImpactVsFuturePrice",
                                  "label-width": "230px",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [_vm._v("Cost Impact (K RMB)")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "line-height": "1" },
                                    attrs: { slot: "label" },
                                    slot: "label",
                                  },
                                  [_vm._v("vs Future Price (if available)")]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.nfcAdminSubmit,
                                    type: "textarea",
                                    rows: 2,
                                    title: _vm.formData.costImpactVsFuturePrice,
                                  },
                                  model: {
                                    value: _vm.formData.costImpactVsFuturePrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "costImpactVsFuturePrice",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.costImpactVsFuturePrice",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "riskIdentifiHedgeJustifi",
                                  rules: _vm.fpaRules.riskIdentifiHedgeJustifi,
                                  "label-width": "230px",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _vm._v(
                                      "Risk Identification & Hedge Justification"
                                    ),
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.nfcAdminSubmit,
                                    type: "textarea",
                                    rows: 5,
                                    title:
                                      _vm.formData.riskIdentifiHedgeJustifi,
                                  },
                                  model: {
                                    value:
                                      _vm.formData.riskIdentifiHedgeJustifi,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "riskIdentifiHedgeJustifi",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.riskIdentifiHedgeJustifi",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isSupplier &&
                    (_vm.nfcAdminSubmit ||
                      _vm.formData.status === "nfcApproved" ||
                      _vm.formData.status === "headOfMenuSolution" ||
                      _vm.formData.status === "menuVpApproving" ||
                      _vm.formData.status === "scmVpApproving" ||
                      _vm.formData.status === "CFOApproving" ||
                      _vm.formData.status === "CEOApproving" ||
                      _vm.formData.status === "CGOApproving" ||
                      _vm.formData.status === "approved")
                      ? _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "info_box_title",
                                staticStyle: { "padding-top": "10px" },
                              },
                              [
                                _c("p", { staticClass: "line" }),
                                _c("p", { staticClass: "info_title" }, [
                                  _vm._v("LTO Material Information"),
                                ]),
                              ]
                            ),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 5 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          label: "Total LTO SKU Count",
                                          "label-width": "130px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.formData.skuQty,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "skuQty",
                                                $$v
                                              )
                                            },
                                            expression: "formData.skuQty",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 5 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          label: "Total Supplier Count",
                                          "label-width": "130px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.formData.supplierQty,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "supplierQty",
                                                $$v
                                              )
                                            },
                                            expression: "formData.supplierQty",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "210px",
                                            "line-height": "32px",
                                            color: "#606266",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " To Compare with Menu Cutting Cost, "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "calc((100% - 230px) / 3)",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                prop: "samePriceQty",
                                                label: "Price Same SKU Count",
                                                "label-width": "150px",
                                                rules:
                                                  _vm.fpaRules.samePriceQty,
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: !_vm.nfcAdminSubmit,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.handleInput(
                                                      $event,
                                                      "samePriceQty"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.samePriceQty,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "samePriceQty",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.samePriceQty",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "calc((100% - 230px) / 3)",
                                            "margin-left": "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                prop: "decPriceQty",
                                                label:
                                                  "Price Reduction SKU Count",
                                                "label-width": "175px",
                                                rules: _vm.fpaRules.decPriceQty,
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: !_vm.nfcAdminSubmit,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.handleInput(
                                                      $event,
                                                      "decPriceQty"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.decPriceQty,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "decPriceQty",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.decPriceQty",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "calc((100% - 230px) / 3)",
                                            "margin-left": "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                prop: "incPriceQty",
                                                label: "Price Rise SKU Count",
                                                "label-width": "145px",
                                                rules: _vm.fpaRules.incPriceQty,
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: !_vm.nfcAdminSubmit,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.handleInput(
                                                      $event,
                                                      "incPriceQty"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.incPriceQty,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "incPriceQty",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.incPriceQty",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          label: "Price Fluctuation Reason",
                                          "label-width": "150px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "textarea",
                                            rows: "3",
                                            disabled: !_vm.nfcAdminSubmit,
                                          },
                                          model: {
                                            value:
                                              _vm.formData
                                                .priceVolatilityReason,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "priceVolatilityReason",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.priceVolatilityReason",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      (_vm.formData.status == "new" && _vm.nfsLists.length > 0) ||
      _vm.formData.status != "new" ||
      _vm.canDownload ||
      _vm.formData.ttFpaLtoCampaignId > 0
        ? _c(
            "div",
            { staticClass: "tab_box" },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { "margin-top": "10px" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _vm.formData.status == "new" && _vm.nfsLists.length > 0
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "PQCP", name: "fpaPqcpTab" } },
                        [
                          _c(
                            "el-tabs",
                            {
                              attrs: { type: "border-card" },
                              on: { "tab-click": _vm.handleClick },
                              model: {
                                value: _vm.selName,
                                callback: function ($$v) {
                                  _vm.selName = $$v
                                },
                                expression: "selName",
                              },
                            },
                            [
                              _c(
                                "el-tab-pane",
                                { attrs: { label: "全部", name: "all" } },
                                [
                                  _vm.canUpdate
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-right": "10px",
                                          },
                                          attrs: { type: "primary" },
                                          on: { click: _vm.fpaNfsAllDownload },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "fpaManage.ltoCampaign.download"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "UTable",
                                    {
                                      ref: "fpaLtoPqcnList",
                                      staticClass: "campaign_table PQCP",
                                      staticStyle: { "margin-top": "10px" },
                                      attrs: {
                                        data: _vm.formData.fpaLtoPqcnList,
                                        height: 520,
                                        "use-virtual": "",
                                        "max-height": "520",
                                        border: "",
                                        "highlight-current-row": "",
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleFpaLtoPqcnChange,
                                      },
                                    },
                                    [
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          type: "index",
                                          width: "55",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "supplierName",
                                          label: "Supplier",
                                          width: "150px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "plantName",
                                          label: "Facility",
                                          width: "150px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "dcIdList",
                                          label: "Supplied DC",
                                          width: "300px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("ic-select", {
                                                    staticClass: "multiple_sel",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      table: "BASE",
                                                      field: "DC",
                                                      multiple: true,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value: scope.row.dcIdList,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "dcIdList",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.dcIdList",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          83579322
                                        ),
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "localItem",
                                          label: _vm.$t(
                                            "fpaManage.ltoCampaign.localItem"
                                          ),
                                          width: "130px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "ingredient",
                                          label: "供应物料 Ingredient",
                                          width: "150px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "localItemContrast",
                                          label: _vm.$t(
                                            "fpaManage.ltoCampaign.localItemContrast"
                                          ),
                                          width: "130px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "ingredientContrast",
                                          label: "对比物料 Ingredient",
                                          width: "150px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "newMenuItemName",
                                          label: "Menu Item",
                                          width: "150px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "purchaseForcast",
                                          label: "Price per Case(wo VAT)",
                                          width: "150px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "pricePerCaseContrast",
                                          label:
                                            "对比物料Price per Case(wo VAT)",
                                          width: "195px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                          prop: "vat",
                                          label: "VAT",
                                          width: "80px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("ic-select", {
                                                    staticClass: "multiple_sel",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      table:
                                                        "TM_MATERIAL_RECORD",
                                                      field: "URCHASE_TAX_RATE",
                                                      disabled: true,
                                                    },
                                                    model: {
                                                      value: scope.row.vat,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "vat",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.vat",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          901378510
                                        ),
                                      }),
                                      _c(
                                        "u-table-column",
                                        {
                                          attrs: {
                                            "show-overflow-tooltip": "",
                                            align: "center",
                                            label:
                                              "Price per UNIT(RMB EXCL.VAT)",
                                            width: "250px",
                                          },
                                        },
                                        [
                                          _c("u-table-column", {
                                            attrs: {
                                              align: "center",
                                              prop: "pricePerUnit",
                                              label: "Price",
                                              width: "150px",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        attrs: {
                                                          value:
                                                            scope.row
                                                              .pricePerUnit,
                                                          disabled: "",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2577197338
                                            ),
                                          }),
                                          _c("u-table-column", {
                                            attrs: {
                                              "show-overflow-tooltip": "",
                                              align: "center",
                                              prop: "unit",
                                              label: "Unit",
                                              width: "150px",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("ic-select", {
                                                        staticClass:
                                                          "multiple_sel",
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          table:
                                                            "TT_FPA_LTO_PQCN",
                                                          field: "UNIT",
                                                          disabled: true,
                                                        },
                                                        model: {
                                                          value: scope.row.unit,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "unit",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.unit",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3580750453
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "u-table-column",
                                        {
                                          attrs: {
                                            "show-overflow-tooltip": "",
                                            align: "center",
                                            label:
                                              "对比物料Price per UNIT(RMB EXCL.VAT)",
                                            width: "250px",
                                          },
                                        },
                                        [
                                          _c("u-table-column", {
                                            attrs: {
                                              align: "center",
                                              prop: "pricePerUnitContrast",
                                              label: "Price",
                                              width: "150px",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        attrs: {
                                                          value: _vm._f(
                                                            "thousandSeparator"
                                                          )(
                                                            scope.row
                                                              .pricePerUnitContrast
                                                          ),
                                                          disabled: "",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1638349986
                                            ),
                                          }),
                                          _c("u-table-column", {
                                            attrs: {
                                              "show-overflow-tooltip": "",
                                              align: "center",
                                              prop: "unitContrast",
                                              label: "Unit",
                                              width: "150px",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("ic-select", {
                                                        staticClass:
                                                          "multiple_sel",
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          table:
                                                            "TT_FPA_LTO_PQCN",
                                                          field: "UNIT",
                                                          disabled: true,
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .unitContrast,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "unitContrast",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.unitContrast",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2614044951
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "u-table-column",
                                        {
                                          attrs: {
                                            align: "center",
                                            label: "Price Valid Date",
                                            width: "150px",
                                          },
                                        },
                                        [
                                          _c("u-table-column", {
                                            attrs: {
                                              align: "center",
                                              prop: "priceValidDateFrom",
                                              label: "From",
                                              width: "100px",
                                              "show-overflow-tooltip": "",
                                            },
                                          }),
                                          _c("u-table-column", {
                                            attrs: {
                                              align: "center",
                                              prop: "priceValidDateTo",
                                              label: "to",
                                              width: "100px",
                                              "show-overflow-tooltip": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "totalEstimatedQty",
                                          label: "Total Estimated Qty(Case)",
                                          width: "150px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "totalEstimatedAmount",
                                          label: "Total Estimated Amount (RMB)",
                                          width: "220px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "thousandSeparator"
                                                        )(
                                                          _vm._f("fix")(
                                                            scope.row
                                                              .totalEstimatedAmount,
                                                            2
                                                          )
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3224739947
                                        ),
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "transportaionMethod",
                                          label: "Delivery Type",
                                          width: "150px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("ic-select", {
                                                    staticClass: "multiple_sel",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      table: "TT_FPA_LTO_PQCN",
                                                      field: "DIS_TYPE",
                                                      disabled: true,
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .transportaionMethod,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "transportaionMethod",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.transportaionMethod",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          542952441
                                        ),
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                          prop: "tradeTerm",
                                          label: "Trade Term",
                                          width: "180px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("ic-select", {
                                                    staticClass: "multiple_sel",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      table:
                                                        "TM_MATERIAL_RECORD",
                                                      field: "PRICE_TYPE",
                                                      disabled: true,
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.tradeTerm,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "tradeTerm",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.tradeTerm",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2569885275
                                        ),
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "freight",
                                          label: "Freight",
                                          width: "150px",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "totalCost",
                                          label: "Total Cost(without VAT)",
                                          width: "170px",
                                          "show-overflow-tooltip": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f(
                                                        "thousandSeparator"
                                                      )(scope.row.totalCost)
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          508755310
                                        ),
                                      }),
                                      _c(
                                        "u-table-column",
                                        {
                                          attrs: {
                                            align: "center",
                                            label: "Promotion Date",
                                            width: "300px",
                                          },
                                        },
                                        [
                                          _c("u-table-column", {
                                            attrs: {
                                              align: "center",
                                              prop: "promotionDateFrom",
                                              label: "From",
                                              width: "150px",
                                              "show-overflow-tooltip": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          type: "date",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .promotionDateFrom,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "promotionDateFrom",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.promotionDateFrom",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1416190165
                                            ),
                                          }),
                                          _c("u-table-column", {
                                            attrs: {
                                              align: "center",
                                              prop: "promotionDateTo",
                                              label: "to",
                                              width: "150px",
                                              "show-overflow-tooltip": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          type: "date",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .promotionDateTo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "promotionDateTo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.promotionDateTo",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1771780024
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("u-table-column", {
                                        attrs: {
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                          prop: "remark",
                                          label: "Remark",
                                          width: "180px",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                          prop: "packagingSize",
                                          label: "Packing Size per CASE",
                                          width: "150px",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                          prop: "packingSizePerCaseContrast",
                                          label:
                                            "对比物料Packing Size per CASE",
                                          width: "220px",
                                        },
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "netContent",
                                          label: "Net Content",
                                          width: "150px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "KG/L",
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.netContent,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "netContent",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.netContent",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2324986175
                                        ),
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "netContentContrast",
                                          label: "对比物料Net Content",
                                          width: "150px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "KG/L",
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .netContentContrast,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "netContentContrast",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.netContentContrast",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1564586013
                                        ),
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "nfcCategoryLeaderId",
                                          label: "NFS审批人",
                                          "min-width": "200px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: { disabled: "" },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .nfcCategoryLeaderId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "nfcCategoryLeaderId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.nfcCategoryLeaderId",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.nfcCategoryLeaderList,
                                                      function (item, index) {
                                                        return _c("el-option", {
                                                          key: index,
                                                          attrs: {
                                                            label:
                                                              item.userName,
                                                            value:
                                                              item.tmUserId,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1639371013
                                        ),
                                      }),
                                      _c("u-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "ssCategoryLeaderId",
                                          label: "SS Category leader",
                                          "min-width": "200px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: { disabled: "" },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .ssCategoryLeaderId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "ssCategoryLeaderId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.ssCategoryLeaderId",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.ssCategoryLeaderList,
                                                      function (item, index) {
                                                        return _c("el-option", {
                                                          key: index,
                                                          attrs: {
                                                            label:
                                                              item.userName,
                                                            value:
                                                              item.tmUserId,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2752008421
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._l(_vm.childTabs, function (item, index) {
                                return _c(
                                  "el-tab-pane",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      name: String(index),
                                    },
                                  },
                                  [
                                    _c(
                                      "el-form",
                                      {
                                        ref: "ruleForm" + `${index}`,
                                        refInFor: true,
                                        attrs: { model: item },
                                      },
                                      [
                                        _vm.ms_userId == item.tmUserId
                                          ? _c(
                                              "el-row",
                                              {
                                                attrs: {
                                                  type: "flex",
                                                  justify: "start",
                                                },
                                              },
                                              [
                                                _vm.canUpdate
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.fpaNfsAdd(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.addNew"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.canUpdate
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.copyLine(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.copyLine"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.canUpdate
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "danger",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.fpaNfsDel(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("common.del")
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.canUpdate
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "10px",
                                                        },
                                                        attrs: {
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.fpaNfsDownload(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "fpaManage.ltoCampaign.download"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.canUpdate
                                                  ? _c(
                                                      "el-upload",
                                                      {
                                                        ref:
                                                          "upload" + `${index}`,
                                                        refInFor: true,
                                                        staticClass:
                                                          "upload-inline-block",
                                                        attrs: {
                                                          action: "",
                                                          "show-file-list": false,
                                                          "http-request":
                                                            _vm.uploadTemplateConfirm,
                                                          headers: _vm.headers,
                                                          accept: ".xls, .xlsx",
                                                          limit: 1,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              slot: "trigger",
                                                              size: "small",
                                                              type: "primary",
                                                            },
                                                            slot: "trigger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "fpaManage.ltoCampaign.import"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "UTable",
                                          {
                                            ref: "childLists" + `${index}`,
                                            refInFor: true,
                                            staticClass: "campaign_table PQCP",
                                            staticStyle: {
                                              "margin-top": "10px",
                                            },
                                            attrs: {
                                              data: item.lists,
                                              height: 520,
                                              "use-virtual": "",
                                              "max-height": "520",
                                              border: "",
                                              "highlight-current-row": "",
                                            },
                                            on: {
                                              "selection-change":
                                                _vm.handleFpaLtoPqcnChange,
                                            },
                                          },
                                          [
                                            _vm.ms_userId == item.tmUserId
                                              ? _c("u-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    type: "selection",
                                                    width: "55",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "supplierName",
                                                label: "Supplier",
                                                width: "150px",
                                                "show-overflow-tooltip": "",
                                              },
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "plantName",
                                                label: "Facility",
                                                width: "150px",
                                                "show-overflow-tooltip": "",
                                              },
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "dcIdList",
                                                label: "Supplied DC",
                                                width: "300px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".dcIdList",
                                                              rules:
                                                                _vm.dcIdListRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("ic-select", {
                                                              staticClass:
                                                                "multiple_sel",
                                                              staticStyle: {
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                table: "BASE",
                                                                field: "DC",
                                                                multiple: true,
                                                                clearable: true,
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.dcsChange(
                                                                      scope.row,
                                                                      $event
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .dcIdList,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "dcIdList",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.dcIdList",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "localItem",
                                                label: _vm.$t(
                                                  "fpaManage.ltoCampaign.localItem"
                                                ),
                                                width: "145px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".localItem",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "MaterialInput",
                                                              {
                                                                attrs: {
                                                                  mark:
                                                                    !_vm.canUpdate ||
                                                                    (_vm.ms_userId !=
                                                                      item.tmUserId &&
                                                                      !_vm.isOwner)
                                                                      ? "1"
                                                                      : "0",
                                                                  disabled: true,
                                                                },
                                                                on: {
                                                                  pick: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.pickMaterial(
                                                                      $event,
                                                                      scope.$index,
                                                                      scope.row
                                                                    )
                                                                  },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .localItem,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "localItem",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.localItem",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "ingredient",
                                                label: "供应物料 Ingredient",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".ingredient",
                                                              rules:
                                                                _vm.ingredientRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .ingredient,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "ingredient",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.ingredient",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "localItemContrast",
                                                label: _vm.$t(
                                                  "fpaManage.ltoCampaign.localItemContrast"
                                                ),
                                                width: "145px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".localItemContrast",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "MaterialInput",
                                                              {
                                                                attrs: {
                                                                  mark:
                                                                    !_vm.canUpdate ||
                                                                    (_vm.ms_userId !=
                                                                      item.tmUserId &&
                                                                      !_vm.isOwner)
                                                                      ? "2"
                                                                      : "0",
                                                                  disabled: true,
                                                                },
                                                                on: {
                                                                  pick: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.pickMaterial1(
                                                                      $event,
                                                                      scope.row
                                                                    )
                                                                  },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .localItemContrast,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "localItemContrast",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.localItemContrast",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "ingredientContrast",
                                                label: "对比物料 Ingredient",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".ingredientContrast",
                                                              rules:
                                                                _vm.eightBitCodeNameRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .ingredientContrast,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "ingredientContrast",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.ingredientContrast",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "newMenuItemName",
                                                label: "Menu Item",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".newMenuItemName",
                                                              rules:
                                                                _vm.newMenuItemNameRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                placeholder:
                                                                  "文字描述",
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .newMenuItemName,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "newMenuItemName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.newMenuItemName",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "purchaseForcast",
                                                label: "Price per Case(wo VAT)",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".purchaseForcast",
                                                              rules:
                                                                _vm.purchaseForcastRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.setPurchaseForcast(
                                                                      scope.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .purchaseForcast,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "purchaseForcast",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.purchaseForcast",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "pricePerCaseContrast",
                                                label:
                                                  "对比物料Price per Case(wo VAT)",
                                                width: "195px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".pricePerCaseContrast",
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                value: _vm._f(
                                                                  "thousandSeparator"
                                                                )(
                                                                  scope.row
                                                                    .pricePerCaseContrast
                                                                ),
                                                                disabled: "",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.setPricePerCaseContrast(
                                                                      scope.row
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "vat",
                                                label: "VAT",
                                                width: "90px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".vat",
                                                              rules:
                                                                _vm.vatRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("ic-select", {
                                                              staticClass:
                                                                "multiple_sel",
                                                              staticStyle: {
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                table:
                                                                  "TM_MATERIAL_RECORD",
                                                                field:
                                                                  "URCHASE_TAX_RATE",
                                                                clearable: true,
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row.vat,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "vat",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.vat",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c(
                                              "u-table-column",
                                              {
                                                attrs: {
                                                  "show-overflow-tooltip": "",
                                                  align: "center",
                                                  label:
                                                    "Price per UNIT(RMB EXCL.VAT)",
                                                  width: "250px",
                                                },
                                              },
                                              [
                                                _c("u-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    prop: "pricePerUnit",
                                                    label: "Price",
                                                    width: "150px",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "fpaPermanentDetail",
                                                                attrs: {
                                                                  prop:
                                                                    "lists." +
                                                                    scope.$index +
                                                                    ".pricePerUnit",
                                                                  rules:
                                                                    _vm.pricePerUnitRules(
                                                                      scope.$index,
                                                                      scope.row
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    disabled:
                                                                      !_vm.canUpdate ||
                                                                      (_vm.ms_userId !=
                                                                        item.tmUserId &&
                                                                        !_vm.isOwner),
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.setPricePerUnit(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      scope.row
                                                                        .pricePerUnit,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          scope.row,
                                                                          "pricePerUnit",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "scope.row.pricePerUnit",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("u-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    prop: "unit",
                                                    label: "Unit",
                                                    width: "150px",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "fpaPermanentDetail",
                                                                attrs: {
                                                                  prop:
                                                                    "lists." +
                                                                    scope.$index +
                                                                    ".unit",
                                                                  rules:
                                                                    _vm.unitRules(
                                                                      scope.$index,
                                                                      scope.row
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "ic-select",
                                                                  {
                                                                    staticClass:
                                                                      "multiple_sel",
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      table:
                                                                        "TT_FPA_LTO_PQCN",
                                                                      field:
                                                                        "UNIT",
                                                                      clearable: true,
                                                                      disabled:
                                                                        !_vm.canUpdate ||
                                                                        (_vm.ms_userId !=
                                                                          item.tmUserId &&
                                                                          !_vm.isOwner),
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .unit,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "unit",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.unit",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "u-table-column",
                                              {
                                                attrs: {
                                                  "show-overflow-tooltip": "",
                                                  align: "center",
                                                  label:
                                                    "对比物料Price per UNIT(RMB EXCL.VAT)",
                                                  width: "250px",
                                                },
                                              },
                                              [
                                                _c("u-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    prop: "pricePerUnitContrast",
                                                    label: "Price",
                                                    width: "150px",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "fpaPermanentDetail",
                                                                attrs: {
                                                                  prop:
                                                                    "lists." +
                                                                    scope.$index +
                                                                    ".pricePerUnitContrast",
                                                                  rules:
                                                                    _vm.pricePerUnitContrastRules(
                                                                      scope.$index,
                                                                      scope.row
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    disabled:
                                                                      !_vm.canUpdate ||
                                                                      (_vm.ms_userId !=
                                                                        item.tmUserId &&
                                                                        !_vm.isOwner) ||
                                                                      scope.row
                                                                        .localItemContrast ==
                                                                        "NA",
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.setPricePerUnitContrast(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      scope.row
                                                                        .pricePerUnitContrast,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          scope.row,
                                                                          "pricePerUnitContrast",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "scope.row.pricePerUnitContrast",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("u-table-column", {
                                                  attrs: {
                                                    "show-overflow-tooltip": "",
                                                    align: "center",
                                                    prop: "unitContrast",
                                                    label: "Unit",
                                                    width: "150px",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "fpaPermanentDetail",
                                                                attrs: {
                                                                  prop:
                                                                    "lists." +
                                                                    scope.$index +
                                                                    ".unitContrast",
                                                                  rules:
                                                                    _vm.unitContrastRules(
                                                                      scope.$index,
                                                                      scope.row
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "ic-select",
                                                                  {
                                                                    staticClass:
                                                                      "multiple_sel",
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      table:
                                                                        "TT_FPA_LTO_PQCN",
                                                                      field:
                                                                        "UNIT",
                                                                      clearable: true,
                                                                      disabled:
                                                                        !_vm.canUpdate ||
                                                                        (_vm.ms_userId !=
                                                                          item.tmUserId &&
                                                                          !_vm.isOwner) ||
                                                                        scope
                                                                          .row
                                                                          .localItemContrast ==
                                                                          "NA",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .unitContrast,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "unitContrast",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.unitContrast",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "u-table-column",
                                              {
                                                attrs: {
                                                  align: "center",
                                                  label: "Price Valid Date",
                                                  width: "150px",
                                                },
                                              },
                                              [
                                                _c("u-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    prop: "priceValidDateFrom",
                                                    label: "From",
                                                    width: "150px",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "fpaPermanentDetail",
                                                                attrs: {
                                                                  prop:
                                                                    "lists." +
                                                                    scope.$index +
                                                                    ".priceValidDateFrom",
                                                                  rules:
                                                                    _vm.priceValidDateFromRules(
                                                                      scope.$index,
                                                                      scope.row
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-date-picker",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      type: "date",
                                                                      placeholder:
                                                                        "选择日期",
                                                                      "value-format":
                                                                        "yyyy-MM-dd",
                                                                      disabled:
                                                                        !_vm.canUpdate ||
                                                                        (_vm.ms_userId !=
                                                                          item.tmUserId &&
                                                                          !_vm.isOwner),
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .priceValidDateFrom,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "priceValidDateFrom",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.priceValidDateFrom",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("u-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    prop: "priceValidDateTo",
                                                    label: "To",
                                                    width: "150px",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "fpaPermanentDetail",
                                                                attrs: {
                                                                  prop:
                                                                    "lists." +
                                                                    scope.$index +
                                                                    ".priceValidDateTo",
                                                                  rules:
                                                                    _vm.priceValidDateToRules(
                                                                      scope.$index,
                                                                      scope.row
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-date-picker",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      type: "date",
                                                                      placeholder:
                                                                        "选择日期",
                                                                      "value-format":
                                                                        "yyyy-MM-dd",
                                                                      disabled:
                                                                        !_vm.canUpdate ||
                                                                        (_vm.ms_userId !=
                                                                          item.tmUserId &&
                                                                          !_vm.isOwner),
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .priceValidDateTo,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "priceValidDateTo",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.priceValidDateTo",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "totalEstimatedQty",
                                                label:
                                                  "Total Estimated Qty(Case)",
                                                width: "200px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".totalEstimatedQty",
                                                              rules:
                                                                _vm.totalEstimatedQtyRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.countPqcp(
                                                                      scope.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .totalEstimatedQty,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "totalEstimatedQty",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.totalEstimatedQty",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "totalEstimatedAmount",
                                                label:
                                                  "Total Estimated Amount (RMB)",
                                                width: "220px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "thousandSeparator"
                                                              )(
                                                                _vm._f("fix")(
                                                                  scope.row
                                                                    .totalEstimatedAmount,
                                                                  2
                                                                )
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "transportaionMethod",
                                                label: "Delivery Type",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".transportaionMethod",
                                                              rules:
                                                                _vm.transportaionMethodRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("ic-select", {
                                                              staticClass:
                                                                "multiple_sel",
                                                              staticStyle: {
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                table:
                                                                  "TT_FPA_LTO_PQCN",
                                                                field:
                                                                  "DIS_TYPE",
                                                                clearable: true,
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deliveryTypeChange(
                                                                      $event,
                                                                      scope.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .transportaionMethod,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "transportaionMethod",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.transportaionMethod",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                "show-overflow-tooltip": "",
                                                align: "center",
                                                prop: "tradeTerm",
                                                label: "Trade Term",
                                                width: "250px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".tradeTerm",
                                                              rules:
                                                                _vm.tradeTermRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("ic-select", {
                                                              staticClass:
                                                                "multiple_sel",
                                                              staticStyle: {
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                table:
                                                                  "TM_MATERIAL_RECORD",
                                                                field:
                                                                  "PRICE_TYPE",
                                                                clearable: true,
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .tradeTerm,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "tradeTerm",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.tradeTerm",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "freight",
                                                label: "Freight",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop: `lists.${scope.$index}.freight`,
                                                              rules:
                                                                _vm.freightRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner) ||
                                                                  scope.row
                                                                    .transportaionMethod ==
                                                                    "DC",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.countPqcp(
                                                                      scope.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .freight,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "freight",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.freight",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "totalCost",
                                                label:
                                                  "Total Cost(without VAT)",
                                                width: "180px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "thousandSeparator"
                                                            )(
                                                              scope.row
                                                                .totalCost
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c(
                                              "u-table-column",
                                              {
                                                attrs: {
                                                  align: "center",
                                                  label: "Promotion Date",
                                                  width: "150px",
                                                },
                                              },
                                              [
                                                _c("u-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    prop: "promotionDateFrom",
                                                    label: "From",
                                                    width: "150px",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "fpaPermanentDetail",
                                                                attrs: {
                                                                  prop: `lists.${scope.$index}.promotionDateFrom`,
                                                                  rules:
                                                                    _vm.promotionDateFromRules(
                                                                      scope.$index,
                                                                      scope.row
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-date-picker",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      type: "date",
                                                                      "value-format":
                                                                        "yyyy-MM-dd",
                                                                      disabled:
                                                                        !_vm.canUpdate ||
                                                                        (_vm.ms_userId !=
                                                                          item.tmUserId &&
                                                                          !_vm.isOwner),
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .promotionDateFrom,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "promotionDateFrom",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.promotionDateFrom",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("u-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    prop: "promotionDateTo",
                                                    label: "To",
                                                    width: "150px",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "fpaPermanentDetail",
                                                                attrs: {
                                                                  prop: `lists.${scope.$index}.promotionDateTo`,
                                                                  rules:
                                                                    _vm.promotionDateToRules(
                                                                      scope.$index,
                                                                      scope.row
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-date-picker",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      type: "date",
                                                                      "value-format":
                                                                        "yyyy-MM-dd",
                                                                      disabled:
                                                                        !_vm.canUpdate ||
                                                                        (_vm.ms_userId !=
                                                                          item.tmUserId &&
                                                                          !_vm.isOwner),
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .promotionDateTo,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "promotionDateTo",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.promotionDateTo",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("u-table-column", {
                                              attrs: {
                                                "show-overflow-tooltip": "",
                                                align: "center",
                                                prop: "remark",
                                                label: "Remark",
                                                width: "250px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".remark",
                                                              rules:
                                                                _vm.remarkRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.remark",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                "show-overflow-tooltip": "",
                                                align: "center",
                                                prop: "packagingSize",
                                                label: "Packing Size per CASE",
                                                width: "180px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".packagingSize",
                                                              rules:
                                                                _vm.packagingSizeRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .packagingSize,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "packagingSize",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.packagingSize",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                "show-overflow-tooltip": "",
                                                align: "center",
                                                prop: "packingSizePerCaseContrast",
                                                label:
                                                  "对比物料Packing Size per CASE",
                                                width: "220px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop:
                                                                "lists." +
                                                                scope.$index +
                                                                ".packingSizePerCaseContrast",
                                                              rules:
                                                                _vm.packingSizePerCaseContrastRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner) ||
                                                                  scope.row
                                                                    .localItemContrast ==
                                                                    "NA",
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .packingSizePerCaseContrast,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "packingSizePerCaseContrast",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.packingSizePerCaseContrast",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "netContent",
                                                label: "Net Content",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop: `lists.${scope.$index}.netContent`,
                                                              rules:
                                                                _vm.netContentRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                placeholder:
                                                                  "KG/L",
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner),
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .netContent,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "netContent",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.netContent",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "netContentContrast",
                                                label: "对比物料Net Content",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop: `lists.${scope.$index}.netContentContrast`,
                                                              rules:
                                                                _vm.netContentContrastRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                placeholder:
                                                                  "KG/L",
                                                                disabled:
                                                                  !_vm.canUpdate ||
                                                                  (_vm.ms_userId !=
                                                                    item.tmUserId &&
                                                                    !_vm.isOwner) ||
                                                                  scope.row
                                                                    .localItemContrast ==
                                                                    "NA",
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .netContentContrast,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "netContentContrast",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.netContentContrast",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "nfcCategoryLeaderId",
                                                label: "NFS审批人",
                                                width: "150px",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop: `lists.${scope.$index}.nfcCategoryLeaderId`,
                                                              rules:
                                                                _vm.nfcCategoryLeaderIdRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-select",
                                                              {
                                                                attrs: {
                                                                  clearable: "",
                                                                  disabled:
                                                                    !_vm.canUpdate ||
                                                                    (_vm.ms_userId !=
                                                                      item.tmUserId &&
                                                                      !_vm.isOwner),
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .nfcCategoryLeaderId,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "nfcCategoryLeaderId",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.nfcCategoryLeaderId",
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.nfcCategoryLeaderList,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key: index,
                                                                      attrs: {
                                                                        label:
                                                                          item.userName,
                                                                        value:
                                                                          item.tmUserId,
                                                                      },
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("u-table-column", {
                                              attrs: {
                                                align: "center",
                                                prop: "ssCategoryLeaderId",
                                                label: "SS Category leader",
                                                width: "150x",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "fpaPermanentDetail",
                                                            attrs: {
                                                              prop: `lists.${scope.$index}.ssCategoryLeaderId`,
                                                              rules:
                                                                _vm.ssCategoryLeaderIdRules(
                                                                  scope.$index,
                                                                  scope.row
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-select",
                                                              {
                                                                attrs: {
                                                                  clearable: "",
                                                                  disabled:
                                                                    !_vm.canUpdate ||
                                                                    (_vm.ms_userId !=
                                                                      item.tmUserId &&
                                                                      !_vm.isOwner),
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .ssCategoryLeaderId,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "ssCategoryLeaderId",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.ssCategoryLeaderId",
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.ssCategoryLeaderList,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key: index,
                                                                      attrs: {
                                                                        label:
                                                                          item.userName,
                                                                        value:
                                                                          item.tmUserId,
                                                                      },
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.status != "new"
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "PQCP", name: "fpaPqcpTab" } },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "formData2",
                              attrs: { model: _vm.formData },
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { type: "flex", justify: "start" } },
                                [
                                  _vm.formData.status != "new" && _vm.isOwner
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.fpaNfsDownload },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "fpaManage.ltoCampaign.download"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  (_vm.formData.status == "nfcApproving" ||
                                    _vm.formData.status == "nfcApproved" ||
                                    _vm.formData.status == "reject") &&
                                  _vm.isOwner
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-right": "10px",
                                          },
                                          attrs: { type: "primary" },
                                          on: { click: _vm.saveMarks },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "fpaManage.ltoCampaign.saveRemark"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  (_vm.formData.status == "nfcApproving" ||
                                    _vm.formData.status == "nfcApproved" ||
                                    _vm.formData.status == "reject") &&
                                  _vm.isOwner
                                    ? _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          staticClass: "upload-inline-block2",
                                          attrs: {
                                            action: "",
                                            "show-file-list": false,
                                            "http-request":
                                              _vm.uploadUpdateConfirm,
                                            headers: _vm.headers,
                                            accept: ".xls, .xlsx",
                                            limit: 1,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                slot: "trigger",
                                                size: "small",
                                                type: "primary",
                                              },
                                              slot: "trigger",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "fpaManage.ltoCampaign.update"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "el-table",
                                {
                                  ref: "fpaLtoPqcnList1",
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: {
                                    data: _vm.formData.fpaLtoPqcnList,
                                    "row-style": _vm.changeRowBgColorByIsLocal,
                                    "max-height": "500",
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "supplierName",
                                      label: "Supplier",
                                      width: "300px",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "plantName",
                                      label: "Facility",
                                      width: "300px",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "dcIdList",
                                      label: "Supplied DC",
                                      width: "300px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return scope.row.isLocal == "1"
                                              ? [
                                                  _c("ic-select", {
                                                    staticClass: "multiple_sel",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      table: "BASE",
                                                      field: "DC",
                                                      multiple: true,
                                                      clearable: true,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value: scope.row.dcIdList,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "dcIdList",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.dcIdList",
                                                    },
                                                  }),
                                                ]
                                              : undefined
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "newMenuItemName",
                                      label: "Menu Item",
                                      width: "300px",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "ingredient",
                                      label: "Ingredient",
                                      width: "300px",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "localItem",
                                      label: "Local Item#",
                                      width: "100px",
                                    },
                                  }),
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        "show-overflow-tooltip": "",
                                        align: "center",
                                        label: "Price per CASE(RMB EXCL. VAT)",
                                        width: "250px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "purchaseForcast",
                                          label: "Price",
                                          width: "150px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    attrs: {
                                                      value: _vm._f(
                                                        "thousandSeparator"
                                                      )(
                                                        scope.row
                                                          .purchaseForcast
                                                      ),
                                                      disabled: "",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          981389849
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                          prop: "unit",
                                          label: "Unit",
                                          width: "150px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: { disabled: "" },
                                                      model: {
                                                        value: scope.row.uom,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "uom",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.uom",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.uomList,
                                                      function (item, index) {
                                                        return _c("el-option", {
                                                          key: index,
                                                          attrs: {
                                                            label:
                                                              _vm._f(
                                                                "inputChoiceI18n"
                                                              )(item),
                                                            value: item.code,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2746931794
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "vat",
                                      label: "VAT",
                                      width: "90px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: { disabled: "" },
                                                  model: {
                                                    value: scope.row.vat,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "vat",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "scope.row.vat",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.pqcnVatRateList,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        value: item.code,
                                                        label:
                                                          _vm._f(
                                                            "inputChoiceI18n"
                                                          )(item),
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2089205948
                                    ),
                                  }),
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        align: "center",
                                        label: "Price Valid Date",
                                        width: "150px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "priceValidDateFrom",
                                          label: "From",
                                          width: "150px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-date-picker", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      type: "date",
                                                      placeholder: "选择日期",
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .priceValidDateFrom,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "priceValidDateFrom",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.priceValidDateFrom",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2684471346
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "priceValidDateTo",
                                          label: "to",
                                          width: "150px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.isLocal == "1"
                                                    ? _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          type: "date",
                                                          placeholder:
                                                            "选择日期",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .priceValidDateTo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "priceValidDateTo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.priceValidDateTo",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2261903334
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "tradeTerm",
                                      label: "Trade Term",
                                      width: "250px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: { disabled: "" },
                                                  model: {
                                                    value: scope.row.tradeTerm,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "tradeTerm",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.tradeTerm",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.priceTypeList,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          _vm._f(
                                                            "inputChoiceI18n"
                                                          )(item),
                                                        value: item.code,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      594906095
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "totalEstimatedQty",
                                      label: "Total Estimated Qty(Case)",
                                      width: "200px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.isLocal == "1"
                                                ? _c("el-input", {
                                                    attrs: { disabled: "" },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .totalEstimatedQty,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "totalEstimatedQty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.totalEstimatedQty",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      174716230
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "totalEstimatedAmount",
                                      label: "Total Estimated Amount (RMB)",
                                      width: "250px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.isLocal == "1"
                                                ? _c("el-input", {
                                                    attrs: {
                                                      value: _vm._f(
                                                        "thousandSeparator"
                                                      )(
                                                        _vm._f("fix")(
                                                          scope.row
                                                            .totalEstimatedAmount,
                                                          2
                                                        )
                                                      ),
                                                      disabled: "",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1168882009
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "transportaionMethod",
                                      label: "Delivery Type",
                                      width: "150px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: { disabled: "" },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .transportaionMethod,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "transportaionMethod",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.transportaionMethod",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.newTransportaionMethodList,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          _vm._f(
                                                            "inputChoiceI18n"
                                                          )(item),
                                                        value: item.code,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2141277166
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "freight",
                                      label: "Freight",
                                      width: "150px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.isLocal == "1"
                                                ? _c("el-input", {
                                                    attrs: {
                                                      disabled: "",
                                                      value: _vm._f(
                                                        "thousandSeparator"
                                                      )(scope.row.freight),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      637447510
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "totalCost",
                                      label: "Total Cost(without VAT)",
                                      width: "250px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.isLocal == "1"
                                                ? _c("el-input", {
                                                    attrs: {
                                                      disabled: "",
                                                      value: _vm._f(
                                                        "thousandSeparator"
                                                      )(scope.row.totalCost),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1573650524
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "Promotion Date From",
                                      width: "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-date-picker", {
                                                attrs: {
                                                  disabled: "",
                                                  type: "date",
                                                  "value-format": "yyyy-MM-dd",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.promotionDateFrom,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "promotionDateFrom",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.promotionDateFrom",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2346755746
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "Promotion Date To",
                                      width: "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-date-picker", {
                                                attrs: {
                                                  disabled: "",
                                                  type: "date",
                                                  "value-format": "yyyy-MM-dd",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.promotionDateTo,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "promotionDateTo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.promotionDateTo",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      267538287
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      align: "center",
                                      prop: "remark",
                                      label: "Remark",
                                      width: "250px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.isLocal == "1"
                                                ? _c("el-input", {
                                                    attrs: {
                                                      disabled: !(
                                                        (_vm.formData.status ==
                                                          "nfcApproving" ||
                                                          _vm.formData.status ==
                                                            "nfcApproved" ||
                                                          _vm.formData.status ==
                                                            "reject") &&
                                                        _vm.isOwner
                                                      ),
                                                    },
                                                    model: {
                                                      value: scope.row.remark,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "remark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.remark",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3626303488
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "packagingSize",
                                      label: "Packing Size per CASE",
                                      width: "250px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input", {
                                                attrs: { disabled: "" },
                                                model: {
                                                  value:
                                                    scope.row.packagingSize,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "packagingSize",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.packagingSize",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4078936393
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "netContent",
                                      label: "Net Content",
                                      width: "250px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input", {
                                                attrs: { disabled: "" },
                                                model: {
                                                  value: scope.row.netContent,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "netContent",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.netContent",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1693250597
                                    ),
                                  }),
                                  _vm.isOwner || _vm.attachmentView
                                    ? _c("el-table-column", {
                                        attrs: {
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                          label: _vm.$t("common.attachment"),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.isLocal == "1"
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.localItemAttachmentUpload(
                                                                scope.row
                                                                  .ttFpaLtoId
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.attachment"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1079409950
                                        ),
                                      })
                                    : _vm._e(),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "nfcCategoryLeaderId",
                                      label: "NFS 审批人",
                                      width: "250px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: { disabled: "" },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .nfcCategoryLeaderId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "nfcCategoryLeaderId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.nfcCategoryLeaderId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.nfcCategoryLeaderList,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.userName,
                                                        value: item.tmUserId,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1639371013
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "ssCategoryLeaderId",
                                      label: "SS Category Leader",
                                      width: "250px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: { disabled: "" },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .ssCategoryLeaderId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "ssCategoryLeaderId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.ssCategoryLeaderId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.ssCategoryLeaderList,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.userName,
                                                        value: item.tmUserId,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2752008421
                                    ),
                                  }),
                                  (_vm.formData.status == "nfcApproving" ||
                                    _vm.formData.status == "nfcApproved" ||
                                    _vm.formData.status == "reject") &&
                                  _vm.isOwner
                                    ? _c("el-table-column", {
                                        attrs: {
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                          label: _vm.$t("common.operation"),
                                          width: "150x",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.isLocal == "1" &&
                                                  scope.row.ltoStatus ==
                                                    "submited"
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.ltoPqcnReject(
                                                                scope.row
                                                                  .ttFpaLtoId
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "fpaManage.permanent.auditReject"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1244707690
                                        ),
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.canDownload
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "Attachment", name: "attachment" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "table",
                              attrs: {
                                data: _vm.attachmentList,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "type",
                                  align: "center",
                                  label: "Type",
                                  width: "200px",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "documentName",
                                  label: "Attachment",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.attachmentDownload(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.documentName)
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2593540249
                                ),
                              }),
                              _vm.nfcAdminSubmit
                                ? _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      label: "Operation",
                                      width: "220px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.type ===
                                              "Other Document"
                                                ? _c(
                                                    "el-upload",
                                                    {
                                                      ref: "upload",
                                                      staticStyle: {
                                                        display: "inline-block",
                                                        width: "70px",
                                                      },
                                                      attrs: {
                                                        action: "",
                                                        "show-file-list": false,
                                                        "http-request": (
                                                          uploadFile
                                                        ) =>
                                                          _vm.uploadOtherDocConfirm(
                                                            uploadFile,
                                                            scope.row
                                                          ),
                                                        headers: _vm.headers,
                                                        limit: 1,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            slot: "trigger",
                                                            size: "small",
                                                            type: "text",
                                                          },
                                                          slot: "trigger",
                                                        },
                                                        [_vm._v(" Upload ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              scope.row.type ===
                                                "Other Document" &&
                                              scope.$index > 1
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.delOtherDoc(
                                                            scope.row,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Delete")]
                                                  )
                                                : _vm._e(),
                                              scope.row.type ===
                                              "Other Document"
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: _vm.addOtherDoc,
                                                      },
                                                    },
                                                    [_vm._v("Add")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3501523085
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.ttFpaLtoCampaignId > 0
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "Audit Record", name: "fpaLog" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "table",
                              attrs: {
                                data: _vm.formData.auditLogList,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "operatorName",
                                  align: "center",
                                  label: "Update by",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "createDate",
                                  align: "center",
                                  label: "Update Time",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("dateFormatFilter")(
                                                  scope.row.createDate,
                                                  "YYYY-MM-DD"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3592427407
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "action",
                                  align: "center",
                                  label: "Update Log",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "comments",
                                  align: "center",
                                  label: "Suggestion",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  align: "center",
                                  label: "Attachment",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("dateFormatFilter")(
                                                  scope.row.effectiveBeginDate,
                                                  "YYYY-MM-DD HH:mm"
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c("fileList", {
                                            attrs: { files: scope.row.docs },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3282433868
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showFileUpload,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFileUpload = $event
            },
          },
        },
        [
          _c("FileUpload", {
            ref: "fileUploadRef",
            attrs: {
              recType: _vm.bizType,
              bizId: _vm.formData.ttFpaLtoCampaignId,
              seq: 2,
              showFileList: true,
              disabled: _vm.fileUploadDisabled,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            visible: _vm.showAuditPage,
            "append-to-body": "",
            width: "25%",
            title: _vm.dialogTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAuditPage = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "formData", attrs: { model: _vm.formData } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20, offset: 2 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class:
                            _vm.dialogTitle == "Reject" ? "is-required" : "",
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("fpaManage.permanent.auditRemark"),
                            prop: "auditRemark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.formData.auditRemark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "auditRemark", $$v)
                              },
                              expression: "formData.auditRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoCampaignApproveConfirm("confirm")
                        },
                      },
                    },
                    [_vm._v("Confirm")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showAuditPage = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.localItemShowFileUpload,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.localItemShowFileUpload = $event
            },
          },
        },
        [
          _c("FileUpload", {
            ref: "fileUploadRef",
            attrs: {
              recType: _vm.localItemBizType,
              bizId: _vm.ttFpaLtoId,
              seq: 0,
              showFileList: true,
              disabled: _vm.localItemFileUploadDisabled,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showRejectPage,
            "append-to-body": "",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRejectPage = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticStyle: { "margin-top": "10px" },
              attrs: { model: _vm.formData, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "is-required",
                          attrs: {
                            label: _vm.$t("fpaManage.permanent.auditRemark"),
                            prop: "auditRemark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3, width: "100%" },
                            model: {
                              value: _vm.formData.auditRemark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "auditRemark", $$v)
                              },
                              expression: "formData.auditRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { attrs: { align: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.ltoPqcnRejectConfirm("confirm")
                        },
                      },
                    },
                    [_vm._v("Confirm")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showRejectPage = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.nfsDialog, "append-to-body": "", width: "80%" },
          on: {
            "update:visible": function ($event) {
              _vm.nfsDialog = $event
            },
          },
        },
        [
          _c("NFS", {
            ref: "nfsRef",
            attrs: { nfsArr: _vm.nfsArr, index: _vm.index },
            on: { getSelNfs: _vm.getSelNfs },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }